import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReportGroup, ReportObject, PageContent, ConversationResult } from 'src/app/objects/WorkObject';
import { DomSanitizer } from '../../../node_modules/@angular/platform-browser';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-reportgroup',
  templateUrl: './reportgroup.component.html',
  styleUrls: ['./reportgroup.component.css']
})
export class ReportgroupComponent implements OnInit {

  private variables:object = {};
  private gridColumns:string;
  private gridRows: string;
  private msGridColumns: string = "";
  private msGridRows: string = "";
  private gridColumnsDefaultArray = [];
  private gridRowsDefaultArray = [];
  private currentReportWidth:number;
  reportGroup:ReportGroup;

  @Input() set getReportGroup(content:any)
  {
      this.promiseGetEpicGroup(content.EPICPageId, content.EPICContentId).then(result => {
        var reportGroup:ReportGroup = JSON.parse(result);
        this.reportGroup = JSON.parse(result);

        this.reportGroup.StartRow = this.posY == 0 ? 1 : this.posY;
        this.reportGroup.StartColumn = this.posX == 0 ? 1 : this.posX;
        
        this.sortReports(this.reportGroup.EPICs);
        this.setStartRow(this.reportGroup.EPICs);
        this.setStartColumn(this.reportGroup.EPICs);

        this.gridColumnsDefaultArray = Array(this.reportGroup.Width).fill("1fr");
        this.gridRowsDefaultArray = Array(this.reportGroup.Height).fill("minmax(0px, 1fr)");

        this.reportGroup.EPICs.filter(x => x.FixWidth > 0).forEach(epic => {
          this.constructGridColumns(epic);
        });

        this.reportGroup.EPICs.filter(x => x.FixHeight > 0).forEach(epic => {
          this.constructGridRows(epic);
        });

        this.buildUltimateGridColumns();
        this.buildUltimateGridRows();

        this.emitReportGroup.emit(this.reportGroup);
      })
  }

  @Input() set setReportGroup(reportGroup:ReportGroup)
  {
      this.reportGroup = reportGroup;
      
      this.sortReports(this.reportGroup.EPICs);
      this.setStartRow(this.reportGroup.EPICs);
      this.setStartColumn(this.reportGroup.EPICs);

      this.gridColumnsDefaultArray = Array(this.reportGroup.Width).fill("1fr");
      this.gridRowsDefaultArray = Array(this.reportGroup.Height).fill("minmax(0px, 1fr)");

      this.reportGroup.EPICs.filter(x => x.FixWidth > 0).forEach(epic => {
        this.constructGridColumns(epic);
      });

      this.reportGroup.EPICs.filter(x => x.FixHeight > 0).forEach(epic => {
        this.constructGridRows(epic);
      });

      this.buildUltimateGridColumns();
      this.buildUltimateGridRows();
  }

  @Input() pageContent:PageContent;
  @Input() hasGap: boolean;
  @Input() isFixHeight: boolean;
  @Input() dialog: boolean = false;
  @Input() posX: number;
  @Input() posY: number;
  @Output() emitReportGroup = new EventEmitter<ReportGroup>();
  @Output() getRelatedEpics = new EventEmitter<ReportGroup>();
  @Output() setFixedHeight = new EventEmitter<any>();

  constructor(private sanitizer: DomSanitizer, private workspaceService:WorkspaceService) {}

  ngOnInit() {
    
  }

  promiseGetEpicGroup(epicPageId: string, groupId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.workspaceService.getEPICGroup(epicPageId, groupId).subscribe(result=>{
        resolve(result);
      });
    });
  }

  constructGridColumns(report:ReportObject){
    var startColumn = report.StartColumn - 1;
    for(var i = 0; i < report.Width; i++){
      this.gridColumnsDefaultArray[startColumn] = report.FixWidth / report.Width + "px";
      startColumn++;
    }
  }

  constructGridRows(report:ReportObject){
    var startRow = report.StartRow - 1;
    for(var i = 0; i < report.Height; i++){
      this.gridRowsDefaultArray[startRow] = report.FixHeight / report.Height + "px";
      startRow++;
    }
  }

  buildUltimateGridRows(){
    var ultimateRows:string = "";
    var msUltimateRows: string = "";
    var array = this.gridRowsDefaultArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index);  //remove duplicates
    this.setFixedHeight.emit(this.gridRowsDefaultArray);
    array.forEach(element => {
        ultimateRows = ultimateRows + "repeat(" + this.gridRowsDefaultArray.filter(x => x == element).length + ", " + element + ") ";
        for (var i =0; i < this.gridRowsDefaultArray.filter(x => x == element).length; i++){
          msUltimateRows = msUltimateRows + element + " ";
        }
    
    })
    this.gridRows = ultimateRows;
    this.msGridRows = msUltimateRows;
  }

  buildUltimateGridColumns(){
    var ultimateColumns:string = "";
    var msUltimateColumns: string = "";

    var array = this.gridColumnsDefaultArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index);  //remove duplicates

    array.forEach(element => {
      ultimateColumns = ultimateColumns + "repeat(" + this.gridColumnsDefaultArray.filter(x => x == element).length + ", " + element + ") ";
      for (var i =0; i < this.gridColumnsDefaultArray.filter(x => x == element).length; i++){
        msUltimateColumns = msUltimateColumns + element + " ";
      }
    })
    this.gridColumns = ultimateColumns;
    this.msGridColumns = msUltimateColumns;
  }

  setStartColumn(report:ReportObject[]){
    var startLine = 0;  // start at line 0
    var endLine = 1;    // end at line 1
    report.forEach(x => {
      x.StartColumn = startLine + endLine;
      endLine = x.StartColumn + x.Width;
      if (x.BreakAfter){
        endLine = 1;
      }
    });
  }

  setStartRow(report:ReportObject[]){
    var startRow = 1;
    report.forEach(x => {
      x.StartRow = startRow;
      if (x.BreakAfter) startRow = startRow + x.Height;
    });
  }

  getRelatedEpic(event){
    this.getRelatedEpics.emit(event);
  }

  UpdateVariable(event:object){
    var tempVariables = Object.assign({}, this.variables);  //just to trigger angular !
    Object.keys(event).forEach(x=> {
      tempVariables[x] = event[x];
    });
    this.variables = tempVariables;
  }

  sortReports(report:ReportObject[]){
    this.reportGroup.EPICs = report.sort((a:ReportObject,b:ReportObject) => {
      if(a.GroupSequence > b.GroupSequence){
        return 1;
      }else if(a.GroupSequence < b.GroupSequence){
        return -1;
      }else{
        return 0;
      }
    });
  }

  togglePanel(bool: boolean, report: ReportObject){
    this.reportGroup.EPICs.find(x => x.EPICId == report.EPICId).IsCollapsed = bool;

    var relatedReport = this.findRelatedEPICs(report, bool);

    var endColumn = report.Width + report.StartColumn - 1;

    if (bool){
      // fix hidden width panel
      for (var i = report.StartColumn - 1; i < endColumn; i++){
        var columnWidth = (20 / report.Width) + "px";
        this.gridColumnsDefaultArray[i] = columnWidth;
      }
    }
    else{
      if (report.FixWidth > 0){
        this.constructGridColumns(report);
      }
      else if (relatedReport){
        if (relatedReport.FixWidth > 0){
          this.constructGridColumns(relatedReport);
        }
      }
      else{
        for (var i = report.StartColumn - 1; i < endColumn; i++){
          this.gridColumnsDefaultArray[i] = "1fr";
        }
      }
    }
    this.buildUltimateGridColumns();
  }

  findRelatedEPICs(report: ReportObject, bool: boolean): ReportObject{
    if (this.reportGroup.EPICs.find(x => x.EPICId == report.EPICId).TemplateType == "ViewList"){
      if (this.reportGroup.EPICs.find(x => x.TemplateType == "QuickLinks")){
        this.reportGroup.EPICs.find(x => x.TemplateType == "QuickLinks").IsCollapsed = bool;
        return this.reportGroup.EPICs.find(x => x.TemplateType == "QuickLinks");
      }
    }
  }
}
